import CheckIcon from '@mui/icons-material/Check'
import { Box, ButtonBase, Typography, useTheme } from '@mui/material'

import useStyles from './index.styles'
import { LocationFilter } from './types'

const FILTER_LABELS: Record<LocationFilter, string> = {
  all: 'All',
  alerting: 'Alerts',
  incomplete: 'Incomplete',
}

interface IProps {
  filter: LocationFilter
  isActive: boolean
  onSelect: (filter: LocationFilter) => void
}

const FilterChip = ({ filter, isActive, onSelect }: IProps) => {
  const classes = useStyles
  const theme = useTheme()

  return (
    <ButtonBase aria-pressed={isActive} onClick={() => onSelect(filter)} sx={classes.filterChip(theme, isActive, filter === 'all')}>
      {isActive && <CheckIcon sx={classes.filterCheckIcon} />}
      {!isActive && filter === 'alerting' && <Box component="span" sx={[classes.alertDot(theme), classes.filterDot]} />}
      {!isActive && filter === 'incomplete' && <Box component="span" sx={[classes.incompleteDot(theme), classes.filterDot]} />}
      <Typography variant="body1" sx={classes.filterLabel}>
        {FILTER_LABELS[filter]}
      </Typography>
    </ButtonBase>
  )
}

export default FilterChip
